import { render, staticRenderFns } from "./ModalCriarNovosMonitoramentos.vue?vue&type=template&id=8343206e&lang=pug"
import script from "./ModalCriarNovosMonitoramentos.vue?vue&type=script&lang=js"
export * from "./ModalCriarNovosMonitoramentos.vue?vue&type=script&lang=js"
import style0 from "./ModalCriarNovosMonitoramentos.vue?vue&type=style&index=0&id=8343206e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports